import styled from '@emotion/styled'
import { calcRem } from '../../../__styling'

export interface RowButtonProps {
    marginBottom?: number
}
const StyledButton = styled.button<RowButtonProps>(
    ({ theme, marginBottom = undefined }) => [
        {
            border: 'none',
            backgroundColor: 'inherit',
            padding: 0,
            cursor: 'pointer',

            '&:hover': {
                textDecoration: 'underline',
            },
        },
        theme.kind == 'thenightly' && {
            display: 'flex',
            marginBottom: marginBottom ? calcRem(marginBottom) : undefined,
        },
        theme.kind === 'perthnow' && {
            display: 'flex',
            gap: calcRem(8),
            paddingTop: calcRem(12),
            paddingBottom: calcRem(12),
        },
    ],
)

StyledButton.displayName = 'StyledButton'
export default StyledButton
